<template>
  <div class="student-data__component">
    <change-billing-due-day-modal
      @close="changeModalVisibility('showBillingDueDayModal', false)"
      :billing="billing"
      v-if="showBillingDueDayModal"
    />
    <billing-cancelation-modal
      @close="changeModalVisibility('showBillingCancelationModal', false)"
      :billing="billing"
      v-if="showBillingCancelationModal"
    />
    <billing-reactivation-modal
      @close="changeModalVisibility('showBillingReactivationModal', false)"
      :billing="billing"
      v-if="showBillingReactivationModal"
    />
    <parcelamento-info-modal
      @close="changeModalVisibility('showParcelamentoInfoModal', false)"
      @installment-loaded="billing.installment = $event"
      :billing="billing"
      v-if="showParcelamentoInfoModal"
    />
    <enrollment-interruption-solicitation-modal
      @close="changeModalVisibility('showEnrollmentInterruptionSolicitationModal', false)"
      @interruption-solicitation-opened="enrollmentInterruptionSolicitationOpened()"
      :contact-preference-id="contactPreference.id"
      v-if="showEnrollmentInterruptionSolicitationModal"
    />
    <debt-agreement-modal
      @close="changeModalVisibility('showDebtAgreementModal', false)"
      @created="reloadContracts()"
      :input-bills="debtAgreementInputBills"
      :institution-id="billing.institution_id"
      v-if="showDebtAgreementModal"
    />
    <billing-update-with-jacad-modal
      @close="changeModalVisibility('showBillingUpdateWithJacadModal', false)"
      :billing="billing"
      v-if="showBillingUpdateWithJacadModal"
    />
    <billing-value-change-modal
      @close="changeModalVisibility('showBillingValueChangeModal', false)"
      :billing="billing"
      v-if="showBillingValueChangeModal"
    />
    <contract-create-modal
      @close="changeModalVisibility('showContractCreateModal', false)"
      :billing="billing"
      v-if="showContractCreateModal"
    />
    <agreement-upload-modal
      @close="changeModalVisibility('showAgreementUploadModal', false)"
      :billing="billing"
      v-if="showAgreementUploadModal"
    />
    <billing-external-id-modal
      @close="changeModalVisibility('showBillingExternalIdModal', false)"
      :billing="billing"
      v-if="showBillingExternalIdModal"
    />
    <change-billing-course-modal
      @close="changeModalVisibility('showChangeBillingCourseModal', false)"
      :billing="billing"
      v-if="showChangeBillingCourseModal"
    />

    <div class="student-view__header-title">
      <h4>
        <strong>
          Dados da cobrança
          <span
            v-if="billing.origin === 'from_parcelamento'"
            class="label label-white label-warning student-view__header-tag"
          >
            {{ billing.translated_origin }}
          </span>
        </strong>
      </h4>
      <div class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle"
          type="button"
          :id="`dropdown-billing-options-${billing.id}`"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          :disabled="!canShowActionsButton()"
        >
          Ações
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" :aria-labelledby="`dropdown-billing-options-${billing.id}`">
          <li v-if="isBillingActiveOrInAdmission && !isBillingFromParcelamentoContinuous">
            <a @click="changeModalVisibility('showBillingCancelationModal', true)">
              Cancelar cobrança
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission">
            <a @click="changeModalVisibility('showBillingDueDayModal', true)">
              Alterar dia de vencimento
            </a>
          </li>
          <li v-if="isBillingActive && billing.origin === 'from_parcelamento'">
            <a @click="changeModalVisibility('showParcelamentoInfoModal', true)">
              Saldo Devedor
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission && canOpenEnrollmentInterruptionSolicitationAction">
            <a @click="changeModalVisibility('showEnrollmentInterruptionSolicitationModal', true)">
              Abrir solicitação de trancamento de matrícula
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission && debtAgreementInputBills && debtAgreementInputBills.length">
            <a @click="changeModalVisibility('showDebtAgreementModal', true)">
              Fazer acordo
            </a>
          </li>
          <li v-if="isBillingActive && isBillingFromUnifcv">
            <a @click="changeModalVisibility('showBillingUpdateWithJacadModal', true)">
              Atualizar mensalidades conforme JACAD
            </a>
          </li>
          <li v-permissions:billing.reactivate v-if="!isBillingActiveOrInAdmission">
            <a @click="changeModalVisibility('showBillingReactivationModal', true)">
              Reativar cobrança
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission">
            <a @click="changeModalVisibility('showBillingValueChangeModal', true)">
              Alterar o valores da cobrança
            </a>
          </li>
          <li v-if="isBillingActive">
            <a @click="changeModalVisibility('showContractCreateModal', true)">
              Criar Contrato
            </a>
          </li>
          <li v-permissions:contract.create_agreement v-if="isBillingActive">
            <a @click="changeModalVisibility('showAgreementUploadModal', true)">
              Subir parcelamento
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission">
            <a @click="changeModalVisibility('showBillingExternalIdModal', true)">
              Alterar External Id da cobrança
            </a>
          </li>
          <li v-if="isBillingActiveOrInAdmission">
            <a @click="changeModalVisibility('showChangeBillingCourseModal', true)">
              Alterar Dados do Curso
            </a>
          </li>
        </ul>
      </div>
    </div>

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Status</th>
          <th>Nome do dependente</th>
          <th>Mensalidade sem desconto</th>
          <th>Mensalidade com desconto</th>
          <th>Porcentagem de desconto</th>
          <th>Semestre de ingresso</th>
          <th>Dia de vencimento</th>
          <th>Origem</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ billing.id }}</td>
          <td>{{ billing.translated_status }}</td>
          <td>{{ billing.dependent_name }}</td>
          <td>{{ billing.installment_value_without_discount | formatCurrency }}</td>
          <td>{{ billing.installment_value_with_discount | formatCurrency }}</td>
          <td>{{ billing.discount_percentage }}%</td>
          <td>{{ billing.enrollment_semester }}</td>
          <td>{{ billing.due_day }}</td>
          <td>{{ billing.translated_origin }}</td>
        </tr>
      </tbody>
    </table>

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Instituição</th>
          <th>Tipo de instituição</th>
          <th>Campus</th>
          <th>Curso</th>
          <th>Nível</th>
          <th>Modalidade</th>
          <th>Período</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ billing.billing_institution.name }}</td>
          <td>{{ billing.billing_institution.translated_kind }}</td>
          <td>{{ billing.billing_institution_place.name }}</td>
          <td>{{ billing.billing_course.name }}</td>
          <td>{{ billing.billing_course.level }}</td>
          <td>{{ billing.billing_course.kind }}</td>
          <td>{{ billing.billing_course.shift }}</td>
        </tr>
      </tbody>
    </table>

    <div class="collapse" :id="`extraBillingData-${billing.id}`">
      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Observações
          </p>
          <p>{{ billing.observations || '-' }}</p>
        </div>
      </div>

      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Metadata da Billing
          </p>
          <pre class="pannel__textarea well well-lg">{{ billingMetadata }}</pre>
        </div>
      </div>

      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Metadata do Curso
          </p>
          <pre class="pannel__textarea well well-lg">{{ billingCourseMetadata }}</pre>
        </div>
      </div>
    </div>
    <div class="show-more--container">
      <button
        class="btn btn-link collapsed show-more"
        type="button"
        data-toggle="collapse"
        :data-target="`#extraBillingData-${billing.id}`"
        aria-expanded="false"
        :aria-controls="`extraBillingData-${billing.id}`"
      >
        <div class="colalapse--opened">
          Mostrar menos
          <span class="glyphicon glyphicon-menu-up" aria-hidden="true"></span>
        </div>
        <div class="colalapse--closed">
          Mostrar mais
          <span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
        </div>
      </button>
    </div>

    <template v-if="reenrollment">
      <hr class="divider divider--spaced-l-bottom">
      <reenrollment-info :reenrollment="reenrollment" />
    </template>

    <hr class="divider divider--spaced-l-bottom">
    <h4 class="student-view__header-title">
      <strong>Contratos desta cobrança</strong>
    </h4>
    <contract-list :billing="billing" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Permissions from 'mixins/Permissions';
import DebtAgreementsService from 'services/DebtAgreementsService';
import ContractList from './ContractList';
import BillingCancelationModal from './modals/BillingCancelationModal';
import BillingReactivationModal from './modals/BillingReactivationModal';
import ChangeBillingDueDayModal from './modals/ChangeBillingDueDayModal';
import ParcelamentoInfoModal from './modals/ParcelamentoInfoModal';
import DebtAgreementModal from './modals/DebtAgreementModal';
import EnrollmentInterruptionSolicitationModal from './modals/EnrollmentInterruptionSolicitationModal';
import ReenrollmentInfo from './ReenrollmentInfo';
import BillingUpdateWithJacadModal from './modals/BillingUpdateWithJacadModal';
import BillingValueChangeModal from './modals/BillingValueChangeModal';
import ContractCreateModal from './modals/ContractCreateModal';
import AgreementUploadModal from './modals/AgreementUploadModal';
import BillingExternalIdModal from './modals/BillingExternalIdModal';
import ChangeBillingCourseModal from './modals/ChangeBillingCourseModal';

export default {
  data() {
    return {
      showBillingValueChangeModal: false,
      showBillingCancelationModal: false,
      showBillingDueDayModal: false,
      showParcelamentoInfoModal: false,
      showEnrollmentInterruptionSolicitationModal: false,
      contactPreferenceDisallowed: false,
      showDebtAgreementModal: false,
      showBillingUpdateWithJacadModal: false,
      showBillingReactivationModal: false,
      showContractCreateModal: false,
      showAgreementUploadModal: false,
      showBillingExternalIdModal: false,
      showChangeBillingCourseModal: false,
      debtAgreementInputBills: [],
    };
  },
  mixins: [Permissions],
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  components: {
    BillingValueChangeModal,
    BillingCancelationModal,
    BillingReactivationModal,
    ContractList,
    ChangeBillingDueDayModal,
    DebtAgreementModal,
    ParcelamentoInfoModal,
    EnrollmentInterruptionSolicitationModal,
    ReenrollmentInfo,
    BillingUpdateWithJacadModal,
    ContractCreateModal,
    AgreementUploadModal,
    BillingExternalIdModal,
    ChangeBillingCourseModal,
  },
  computed: {
    isBillingActive() {
      return this.billing.status === 'active';
    },
    canOpenEnrollmentInterruptionSolicitationAction() {
      return (this.isBillingActive && this.contactPreference && !this.contactPreferenceDisallowed);
    },
    contactPreference() {
      return this.billing.contact_preference;
    },
    billingMetadata() {
      return JSON.stringify(this.billing.metadata, null, 2);
    },
    billingCourseMetadata() {
      return JSON.stringify(this.billing.billing_course.metadata, null, 2);
    },
    isBillingFromUnifcv() {
      return this.billing.institution_id === 2999;
    },
    isBillingActiveOrInAdmission() {
      return ['active', 'in_admission'].includes(this.billing.status);
    },
    reenrollment() {
      return this.billing.reenrollment;
    },
    isBillingFromParcelamentoContinuous() {
      return this.billing.discharge_type === 'continuous';
    },
  },
  mounted() {
    this.contactPreferenceDisallowed = (
      this.contactPreference && this.contactPreference.disallowed_by
    );
    this.loadDebtAgreementInputBills(this.billing.id);
  },
  methods: {
    ...mapActions([
      'loadStudentContracts',
    ]),
    canShowActionsButton() {
      return this.isBillingActiveOrInAdmission
        || this.userPermissions.billing.includes('reactivate');
    },
    changeModalVisibility(modalName, open) {
      this[modalName] = open;
    },
    enrollmentInterruptionSolicitationOpened() {
      this.contactPreferenceDisallowed = true;
      this.showEnrollmentInterruptionSolicitationModal = false;
    },
    reloadContracts() {
      setTimeout(() => {
        this.loadStudentContracts();
        this.loadDebtAgreementInputBills(this.billing.id);
      }, 2000);
    },
    loadDebtAgreementInputBills(billingId) {
      DebtAgreementsService.getInputBills(billingId).then(({ data }) => {
        this.debtAgreementInputBills = data;
      });
    },
  },
};
</script>
